import Classes from "./CountForm.module.css"

export const FrameProfileCountForm = () => {


  return <div className={Classes.main_div}>This is the frame profile count form</div>
}

